import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetBoardDetailResponse } from "../../api/board";

export type TApiBoardDetailResult = {
  result?: GetBoardDetailResponse;
};

export const fetchBoardDetail = async (category_id: number ,board_id: number ): Promise<TApiResult & TApiBoardDetailResult> => {
  const query = {
    query :  { category_id, board_id }
  }; 

  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .board.get({ ...query, ...authHeader })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchBoardDetail");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
